export const LOCATIONS = [
  { 
    value: 'Wildwood Park', 
    address: '114 Bedford St, Burlington, MA 01803',
    coordinates: { lat: 42.5047, lng: -71.1956 }
  },
  { 
    value: 'Simonds Park', 
    address: '10 Bedford St, Burlington, MA 01803',
    coordinates: { lat: 42.5044, lng: -71.1928 }
  },
  { 
    value: 'Burlington Recreation Department', 
    address: '61 Center St, Burlington, MA 01803',
    coordinates: { lat: 42.5058, lng: -71.1944 }
  }
];